module.exports = __webpack_public_path__ + "img/overlay_background.75915327.jpg";